class IvsVideoPlayer {
  constructor() {
    this.player = null;
    this.$modal = $('#ivs-video-modal');
    this.$container = $('#ivs-player-container');
  }

  init() {
    // console.log('IVS: init() called');
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initEvents();
        this.initPlaceholders();
      })
    } else {
      this.initEvents();
      this.initPlaceholders();
    }
  }

  initPlaceholders() {
    const placeholders = document.querySelectorAll('.ivs-video-placeholder');

    placeholders.forEach((placeholder) => {
      const videoUrl = placeholder.getAttribute('data-video-url');
      const videoTitle = placeholder.getAttribute('data-video-title');
      const videoId = placeholder.getAttribute('data-video-id');
      const thumbnailUrl = placeholder.getAttribute('data-video-thumbnail');

      if (videoUrl) {
        const videoContainer = document.createElement('div');
        videoContainer.className = 'ivs-video-embed';

        const thumbnail = document.createElement('div');
        thumbnail.className = 'ivs-video-thumbnail';

        if (thumbnailUrl) {
          thumbnail.style.backgroundImage = `url(${thumbnailUrl})`;
        }

        thumbnail.innerHTML =
          '<div class="ivs-video-play-button">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>' +
          '</div>';

        thumbnail.dataset.ivsVideo = videoUrl;
        thumbnail.dataset.ivsTitle = videoTitle;

        videoContainer.appendChild(thumbnail);

        if (videoTitle) {
          const title = document.createElement('p')
          title.className = 'ivs-video-title';
          title.textContent = videoTitle;
          videoContainer.appendChild(title);
        }

        placeholder.replaceWith(videoContainer);
      }
    })
  }

  initEvents() {
    $(document).on('click', '[data-ivs-video]', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget);
      const videoUrl = $target.data('ivs-video');
      const videoTitle = $target.data('ivs-title') || '';

      this.openVideo(videoUrl, videoTitle);
    });

    this.$modal.on('hidden.bs.modal', () => {
      this.destroyPlayer();
    });
  }

  openVideo(url, title) {
    this.$modal.modal('show');

    this.$modal.one('shown.bs.modal', () => {
      this.createPlayer(url);
    });
  }

  createPlayer(url) {
    if (!window.IVSPlayer || !window.IVSPlayer.isPlayerSupported) {
      console.error('IVS Player not supported');
      return;
    }

    this.destroyPlayer();

    const videoElement = document.getElementById('ivs-video-element');
    this.player = window.IVSPlayer.create();
    this.player.attachHTMLVideoElement(videoElement);
    this.player.load(url);
    this.player.play();
  }

  destroyPlayer() {
    if (this.player) {
      this.player.pause();
      this.player.delete();
      this.player = null;
    }
  }
}

export default IvsVideoPlayer;
